import { getStore } from '../store/store';

export const isTriggerConditionMet = (): boolean => {
    return getStore().isTriggerConditionMet;
};
